"use strict";

let rsvpklaviyoSubscribeLoaded = false;
const rsvpklaviyoSubscribeUrl = '//www.klaviyo.com/media/js/public/klaviyo_subscribe.js';
const rsvpForms = document.querySelectorAll('.rsvp-section');

rsvpForms.forEach(rsvpForm => {

    const successMessage = document.querySelector(".rsvp_success_message");
    const formLabel = document.querySelector(".rsvp_form_label");

    rsvpForm.querySelector('#rsvp-form__email').addEventListener('focus', async () => {
        if (!rsvpklaviyoSubscribeLoaded) {
            await calpak.loadScript(rsvpklaviyoSubscribeUrl);
        }

        if (!rsvpForm.classList.contains('rsvp-section--attached')) {
            rsvpForm.classList.add('rsvp-section--attached');
            KlaviyoSubscribe.attachToModalForm(`.rsvp-section[data-id="${rsvpForm.getAttribute('data-id')}"]`,
                {
                    success: function ($form) {
                        var email = $form.find('[name="email"]').val();

                        if (successMessage) {
                            successMessage.style.display = "block";
                        }
                        if (formLabel) {
                            formLabel.style.display = "none";
                        }

                        // LiveConnect Tag
                        window.liQ = window.liQ || [];
                        window.liQ.push({
                            "event": "conversion",
                            "name": "rsvp_form",
                            "email": email
                        });

                    }
                });
        }
    });
});
